import ModalOptions from './ModalOptions';

export default ModalOptions;
